import axios from './axios';

const getReview = () => {
  return axios.get('/blogs/reviews/');
};

export { getReview };
